import ScrollableItems from "./ScrollableItems";

export default ScrollableItems;
